module.exports = __webpack_public_path__ + "img/review-rating-2.d55c96a2.png";